import { render, staticRenderFns } from "./Logo.vue?vue&type=template&id=4a2ed436&scoped=true&"
import script from "./Logo.vue?vue&type=script&lang=js&"
export * from "./Logo.vue?vue&type=script&lang=js&"
import style0 from "./Logo.vue?vue&type=style&index=0&id=4a2ed436&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a2ed436",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a2ed436')) {
      api.createRecord('4a2ed436', component.options)
    } else {
      api.reload('4a2ed436', component.options)
    }
    module.hot.accept("./Logo.vue?vue&type=template&id=4a2ed436&scoped=true&", function () {
      api.rerender('4a2ed436', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/components/layout/sidebarComponents/Logo.vue"
export default component.exports